'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415 from "./presto.-Freemium2-F-A-Add-View$$anon$15.js";
import * as $j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024 from "./presto.types$-Freemium-Seed-Result$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$14() {
  this.aTn = null;
  this.aTf = null;
  this.aTg = false;
  this.aTo = null;
  this.aTp = false;
  this.aTs = null;
  this.aTl = null;
  this.aTm = false;
  this.aTh = null;
  this.aTi = false;
  this.aTj = null;
  this.aTk = false;
  this.aTq = false;
  this.aTr = false;
  this.aTn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aTs = "FreemiumSeedResult";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$14 as $c_Lpresto_Freemium2FAAddView$$anon$14 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$14;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$14() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$14 as $h_Lpresto_Freemium2FAAddView$$anon$14 };
$h_Lpresto_Freemium2FAAddView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aTn;
});
$p.L = (function() {
  if ((!this.aTg)) {
    this.aTf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aTg = true;
  }
  return this.aTf;
});
$p.O = (function() {
  if ((!this.aTp)) {
    this.aTo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTp = true;
  }
  return this.aTo;
});
$p.E = (function() {
  return this.aTs;
});
$p.t = (function() {
  if ((!this.aTm)) {
    this.aTl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aTm = true;
  }
  return this.aTl;
});
$p.M = (function() {
  if ((!this.aTi)) {
    this.aTh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aTi = true;
  }
  return this.aTh;
});
$p.Q = (function() {
  if ((!this.aTk)) {
    this.aTj = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415.$c_Lpresto_Freemium2FAAddView$$anon$15();
    this.aTk = true;
  }
  return this.aTj;
});
$p.w = (function() {
  if ((!this.aTr)) {
    this.aTq = false;
    this.aTr = true;
  }
  return this.aTq;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee133) => ((p) => \u03b4scrutinee133.cGA(p)))($j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024.$m_Lpresto_types$FreemiumSeedResult$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$14, "presto.Freemium2FAAddView$$anon$14", ({
  IJ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$14 as $d_Lpresto_Freemium2FAAddView$$anon$14 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$14.js.map
